// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ot-0";
export var leftAlign = "_ot-4";
export var listItem = "_ot-2";
export var listItemWrapper = "_ot-1";
export var operationText = "_ot-3";